export * from './product-image.component'